import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * A plugin for handle table custom widths
 * Has login to scan the document, add width value to table's width attribute when necessary
 * Also holds resizing state to hide / show table controls
 */

import { SetAttrsStep } from '@atlaskit/adf-schema/steps';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { ReplaceStep } from '@atlaskit/editor-prosemirror/transform';
import { akEditorFullWidthLayoutWidth, akEditorWideLayoutWidth } from '@atlaskit/editor-shared-styles';
export var pluginKey = new PluginKey('tableWidthPlugin');
var createPlugin = function createPlugin(dispatch, fullWidthEnabled) {
  return new SafePlugin({
    key: pluginKey,
    state: {
      init: function init() {
        return {
          resizing: false
        };
      },
      apply: function apply(tr, pluginState) {
        var meta = tr.getMeta(pluginKey);
        if (meta && meta.resizing !== pluginState.resizing) {
          var newState = {
            resizing: meta.resizing
          };
          dispatch(pluginKey, newState);
          return newState;
        }
        return pluginState;
      }
    },
    appendTransaction: function appendTransaction(transactions, _oldState, newState) {
      // When document first load in Confluence, initially it is an empty document
      // and Collab service triggers a transaction to replace the empty document with the real document that should be rendered.
      // what we need to do is to add width attr to all tables in the real document
      // isReplaceDocumentOperation is checking if the transaction is the one that replace the empty document with the real document
      var isReplaceDocumentOperation = transactions.some(function (tr) {
        if (tr.getMeta('replaceDocument')) {
          return true;
        }
        var hasStepReplacingEntireDocument = tr.steps.some(function (step) {
          if (!(step instanceof ReplaceStep)) {
            return false;
          }
          var isStepReplacingFromDocStart = step.from === 0;
          var isStepReplacingUntilTheEndOfDocument = step.to === _oldState.doc.content.size;
          if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) {
            return false;
          }
          return true;
        });
        return hasStepReplacingEntireDocument;
      });
      if (!isReplaceDocumentOperation) {
        return null;
      }
      var tr = newState.tr;
      var table = newState.schema.nodes.table;
      newState.doc.forEach(function (node, offset) {
        if (node.type === table) {
          var width = node.attrs.width;
          var layout = node.attrs.layout;
          if (!width && layout) {
            var tableWidthCal;
            if (fullWidthEnabled) {
              tableWidthCal = akEditorFullWidthLayoutWidth;
            } else {
              switch (layout) {
                case 'wide':
                  tableWidthCal = akEditorWideLayoutWidth;
                  break;
                case 'full-width':
                  tableWidthCal = akEditorFullWidthLayoutWidth;
                  break;
                // when in fix-width apprearance, no need to assign value to table width attr
                // as when table is created, width attr is null by default, table rendered using layout attr
                default:
                  break;
              }
            }
            var _node$attrs = node.attrs,
              _width = _node$attrs.width,
              rest = _objectWithoutProperties(_node$attrs, _excluded);
            if (tableWidthCal) {
              tr.step(new SetAttrsStep(offset, _objectSpread({
                width: tableWidthCal
              }, rest)));
            }
          }
        }
      });
      return tr;
    }
  });
};
export { createPlugin };